import { tagWall } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

const topics = [
  { rank: 1, title: "一口气刷完的高能悬疑剧", heat: "3.2 万条讨论" },
  { rank: 2, title: "最适合下饭的国产轻喜剧", heat: "2.4 万条讨论" },
  { rank: 3, title: "被低估的冷门高分电影", heat: "1.9 万条讨论" },
  { rank: 4, title: "国产科幻这几年的进步", heat: "1.5 万条讨论" },
  { rank: 5, title: "值得重看的老片修复清单", heat: "1.1 万条讨论" },
];

export default function TagWall() {
  return (
    <section id="tags" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="03"
          title="标签话题墙 · 想看的都能搜到"
          subtitle="按标签与话题快速定位，顺着大家讨论的方向找片"
          actionLabel="全部标签"
          actionHref="#tags"
        />

        <div className="grid gap-4 md:gap-5 lg:grid-cols-3">
          <div className="rounded-xl border border-background-200 bg-background-100 p-5 md:p-6 lg:col-span-2">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-700">
                <i className="ri-price-tag-3-line"></i>
              </span>
              <p className="text-sm text-foreground-700">
                共收录 <strong className="text-foreground-950">20</strong> 个常看标签，点击即可浏览对应片单
              </p>
            </div>
            <div className="flex flex-wrap gap-2 md:gap-2.5">
              {tagWall.map((tag) => (
                <a
                  key={tag.name}
                  href="#tags"
                  className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                    tag.hot
                      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                      : "border border-background-300 bg-background-50 text-foreground-700 hover:border-secondary-400 hover:text-secondary-800"
                  }`}
                >
                  {tag.name}
                  <span
                    className={`text-[11px] ${tag.hot ? "text-background-100/80" : "text-foreground-400"}`}
                  >
                    {tag.count}
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div className="rounded-xl border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="mb-3 flex items-center gap-2 font-heading text-lg text-foreground-950">
              <i className="ri-chat-3-line text-accent-600"></i>
              本周热议话题
            </h3>
            <ul className="space-y-1">
              {topics.map((topic) => (
                <li key={topic.rank}>
                  <a
                    href="#discussions"
                    className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-50"
                  >
                    <span
                      className={`font-heading text-lg ${
                        topic.rank <= 3 ? "text-primary-600" : "text-foreground-400"
                      }`}
                    >
                      {String(topic.rank).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm text-foreground-950 group-hover:text-primary-700">
                        {topic.title}
                      </span>
                      <span className="block text-xs text-foreground-500">{topic.heat}</span>
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-600"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}